import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

import { validateBikeInsuredSum } from './utils'

const contents_bike_insured_sum = (params: StepConfigParams) => {
  const bikeCoveragePath = params.helperFunctions.getParamPath('bike_theft_coverage')
  const bikeInsuredAmountPath = params.helperFunctions.getParamPath('bike_theft_insured_sum_amount')
  const insuredSumConfirmationPath = params.helperFunctions.getHelperPath(
    'insured_sum_confirmation'
  )
  const insuredSumShowConfirmationPath = params.helperFunctions.getHelperPath(
    'insured_sum_show_confirmation'
  )
  return {
    schema: schemaUtils.generateZodObjectFromPaths({
      [bikeCoveragePath]: BaseSchema_ContentsV1GetsafeDe.shape.bike_theft_coverage,
      // Unwrap makes the schema required
      [bikeInsuredAmountPath]:
        BaseSchema_ContentsV1GetsafeDe.shape.bike_theft_insured_sum_amount.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.title',
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        inputType: 'integer',
        name: bikeInsuredAmountPath,
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.input',
        },
        onValueChange: {
          type: 'dispatchedHook',
          callbackConfig: {
            name: 'hideErrorMessageHook',
            inputs: [],
            outputs: [],
          },
        },
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey:
                'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.infoBox.text',
            },
          },
        ],
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_bike_insured_sum.confirmation',
        },
        condition: {
          type: 'value',
          valuePath: insuredSumShowConfirmationPath,
          expectedValue: true,
        },
      },
      {
        type: 'yesNo',
        name: insuredSumConfirmationPath,
        condition: {
          type: 'value',
          valuePath: insuredSumShowConfirmationPath,
          expectedValue: true,
        },
        onValueChange: {
          type: 'dispatchedHook',
          callbackConfig: {
            name: 'hideErrorMessageHook',
            inputs: [],
            outputs: [],
          },
        },
      },
    ],
    subFlow: params.subFlow,
    onSubmit: {
      type: 'simpleHook',
      // TODO: https://hellogetsafe.atlassian.net/browse/BX-426
      // add tests to check if values are reset when user goes back and turns off the extension
      callback: validateBikeInsuredSum(params),
    },
    nextStep: 'contents_glass',
  } as const satisfies AnyStepConfiguration
}

export default contents_bike_insured_sum
